import { ApiError } from '../api';

export function renderErrorBanner(
  host: HTMLElement,
  err: ApiError | Error,
  opts: { onRetry?: () => void; onStartOver?: () => void; onSignIn?: () => void } = {},
): void {
  const friendly = err instanceof ApiError ? err : null;
  const code = friendly?.code ?? 'UNKNOWN_ERROR';
  const message = err.message || 'Something went wrong. Please try again.';
  const retryable = friendly?.retryable ?? true;
  const action = friendly?.action ?? null;

  const card = document.createElement('section');
  card.className = 'card';

  const banner = document.createElement('div');
  banner.className = 'banner error';
  banner.setAttribute('role', 'alert');
  const head = document.createElement('strong');
  head.textContent = 'Something went wrong.';
  const msg = document.createElement('div');
  msg.textContent = message;
  banner.append(head, msg);

  const codeLine = document.createElement('p');
  codeLine.className = 'small muted';
  codeLine.textContent = `Error code: ${code}`;

  const btnRow = document.createElement('div');
  btnRow.className = 'btn-row';

  if (action === 'signin' && opts.onSignIn) {
    const signin = document.createElement('button');
    signin.type = 'button';
    signin.className = 'btn';
    signin.textContent = 'Sign in again';
    signin.addEventListener('click', () => opts.onSignIn?.());
    btnRow.append(signin);
  } else if (retryable && opts.onRetry) {
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'btn';
    retry.textContent = 'Try again';
    retry.addEventListener('click', () => opts.onRetry?.());
    btnRow.append(retry);
  }
  if (opts.onStartOver) {
    const over = document.createElement('button');
    over.type = 'button';
    over.className = 'btn btn-secondary';
    over.textContent = 'Start over';
    over.addEventListener('click', () => opts.onStartOver?.());
    btnRow.append(over);
  }

  card.append(banner, codeLine, btnRow);
  host.replaceChildren(card);
}
